import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Import images
import elfoa2pLogo from '../../assets/elfoa2p-logo.svg';
import giftIcon from '../../assets/icon-gift.svg';
import lockIcon from '../../assets/icon-lock.svg';
import globeIcon from '../../assets/icon-globe.svg';
import sliceIcon from '../../assets/icon-slice.svg';
import elfoa2pGif from '../../assets/elfo-mascot-logo-signin.png';
import sogoLogo from '../../assets/company-sogo.png';
import avonLogo from '../../assets/company-avon.png';
import upstreamLogo from '../../assets/company-upstream.png';
import shakleeLogo from '../../assets/company-shaklee.png';
import fgvLogo from '../../assets/company-fgv.png';
import sprLogo from '../../assets/company-spr.svg';
import timeLogo from '../../assets/company-time.png';
import valiramLogo from '../../assets/company-valiram.png';
import perkesoLogo from '../../assets/logo-perkeso.png';
import secureCommunicationLogo from '../../assets/secure_communication_logo.svg';

const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';

const LeftSection = () => {
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    autoplay: true,
    autoplaySpeed: 3500,
  };

  const settingsMobile = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    autoplay: true,
    autoplaySpeed: 3500,
  };

  return (
    <div className={white_label_perkeso ? "left-container-p" : "left-container"}>
      <img
        alt="..."
        src={white_label_perkeso ? perkesoLogo : elfoa2pLogo}
        height={60}
        className="d-none d-sm-block"
      />
      <h2 style={{ marginBottom: 30 }}>Engage Customers with Automated A2P Messaging</h2>
      {!white_label_perkeso && (
      <p className="subheading-text" style={{ marginBottom: 30 }}>
        Sign up for an elfoA2P account and claim your free credits now!
      </p>
      )}
      <div className="d-none d-sm-flex" style={{ gap: '50px' }}>
        <div>
          <img alt="..." src={!white_label_perkeso ? giftIcon : secureCommunicationLogo} />
          <p>{!white_label_perkeso ? "Free credits, no expiration" : "Personalized and Secure Customer Communication"} </p>
        </div>
        <div>
          <img alt="..." src={lockIcon} />
          <p>{!white_label_perkeso ? "Secure and reliable support" : "Unmatched Security and Compliance"}</p>
        </div>
        <div>
          <img alt="..." src={globeIcon} />
          <p>Global coverage</p>
        </div>
        <div>
          <img alt="..." src={sliceIcon} />
          <p>Real-time analytics and detailed insights</p>
        </div>
      </div>
      <div className="d-flex d-sm-none" style={{ gap: '30px' }}>
        <div>
          <img alt="..." src={giftIcon} />
          <p>Free credits, no expiration</p>
        </div>
        <div>
          <img alt="..." src={globeIcon} />
          <p>Global coverage</p>
        </div>
        <div>
          <img alt="..." src={lockIcon} />
          <p>Secure and reliable support</p>
        </div>
        <div>
          <img alt="..." src={sliceIcon} />
          <p>Real-time analytics and detailed insights</p>
        </div>
      </div>
      <img alt="..." src={elfoa2pGif} height={350} />
      {!white_label_perkeso && (
      <div className="company-logo d-flex flex-column justify-center gap-1">
        <h3 className="text-center text-white mb-0">Trusted By</h3>
        <Slider className="d-none" {...settings}>
          <div className="d-flex justify-content-center align-items-center gap-3">
            <img alt="..." src={sogoLogo} />
            <img alt="..." src={avonLogo} />
            <img alt="..." src={upstreamLogo} />
            <img alt="..." src={shakleeLogo} />
          </div>
          <div className="d-flex justify-content-center align-items-center gap-3">
            <img alt="..." src={fgvLogo} />
            <img alt="..." src={sprLogo} />
            <img alt="..." src={timeLogo} />
            <img alt="..." src={valiramLogo} />
          </div>
        </Slider>
        <Slider className="d-block" {...settingsMobile}>
          <div className="d-flex justify-content-center align-items-center gap-3">
            <img alt="..." src={sogoLogo} />
            <img alt="..." src={avonLogo} />
            <img alt="..." src={upstreamLogo} />
          </div>
          <div className="d-flex justify-content-center align-items-center gap-3">
            <img alt="..." src={shakleeLogo} />
            <img alt="..." src={fgvLogo} />
            <img alt="..." src={sprLogo} />
          </div>
          <div className="d-flex justify-content-center align-items-center gap-3">
            <img alt="..." src={timeLogo} />
            <img alt="..." src={valiramLogo} />
          </div>
        </Slider>
      </div>
      )}
    </div>
  );
};

export default LeftSection;